module.exports = __webpack_public_path__ + "media/src/assets/img/elements/iphone-x-ff1daa9ec97c4edc151eedaea4082345.png";